module.exports = __webpack_public_path__ + "img/icon_blue_fork-knife.60c90e5b.svg";